
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'RewardsBadgeWithColor',
})
class RewardsBadgeWithColor extends Vue {
	@Prop({ type: String, default: '' })
	someProp: string;
}

export default RewardsBadgeWithColor;
